import { render, staticRenderFns } from "./LanguageConcept.vue?vue&type=template&id=e2cc0108&scoped=true&"
import script from "./LanguageConcept.vue?vue&type=script&lang=js&"
export * from "./LanguageConcept.vue?vue&type=script&lang=js&"
import style0 from "./LanguageConcept.vue?vue&type=style&index=0&id=e2cc0108&prod&lang=scss&scoped=true&"
import style1 from "./LanguageConcept.vue?vue&type=style&index=1&id=e2cc0108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cc0108",
  null
  
)

export default component.exports